import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import {
    Theme,
    createStyles,
    withStyles,
    WithStyles,
    Card,
    CardContent,
    Grid,
    Typography,
    Chip,
    Button
} from '@material-ui/core';
import {
    MyPATDialog,
    MyPATTextField,
    MyPATIconButton
} from '../../common';


import {
    EditOutlined as EditIcon,
    CloseOutlined as CloseIcon,
} from '@material-ui/icons';
import goalManagementService from '../services/goalManagementService';

const styles = (theme: Theme) => createStyles({
    disableField: {
        '& .textField': {
        background: "hsl(0deg 0% 95%)",
        },
        '& input': {
            cursor: 'not-allowed'
        }
    },
    borderStyle: {
        '& svg': {
            fontSize: 28
        },
        border: '0',
        margin: '0px 0px 0px 18px',
        backgroundColor: '#fff',
        borderRadius: 50,
        width: 30,
        height: 30,
        '&:hover': {
            color: '#333333'
        }
    },
    btnEdit: {
        color: '#fff',
        border: 'solid 1px #1D7DEA',
        fontSize: '1rem',
        boxSizing: 'border-box',
        background: '#1D7DEA',
        padding: 0
    },
    btnDisable: {
        opacity: 0.5,
        color: "#fff !important"
    },
    btnHover: {
        '&:hover': {
            backgroundColor: '#1D7DEA',
        }
    },
    card: {
        margin: '14px 0px -2px'
    },
    mb1x: {
        marginBottom: theme.spacing.unit,
    },
    cardContentRoot: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        }
    },
    subSubjectChip: {
        color: theme.palette.common.white,
        marginLeft: theme.spacing.unit,
        marginBottom: theme.spacing.unit / 2,
        height: 24
    },
    chipLightRed: {
        background: '#F08D80',
        fontWeight: 600,
    },
    chipLightBlue: {
        background: '#809FF0',
        fontWeight: 600,

    },
    chipLightGreen: {
        background: '#67BF02',
    },
    title: {
        fontSize: 15,
        color: theme.palette.text.primary,
        paddingRight: theme.spacing.unit,
        "& > span": {
            color: theme.palette.error.light,
        }
    },
    dialogCloseContainer: {
        textAlign: 'right',
    },
    inline: {
        display: "inline"
    },
    editTitle: {
        position: 'relative',
    },
    editIcon: {
        position: 'absolute',
        left: '30px',
        color: '#2E97F9',
        cursor: 'pointer',
        zIndex: 1000,
    },
    masters: {
        fontFamily: 'Nunito',
        lineHeight: '36px',
        verticalAlign: 'middle',
        padding: '0 16px',
        width: '100%',
        border: '1px solid #e0e0e0',
        borderRadius: 4,
        whiteSpace: 'nowrap',
        overflow: 'auto',
        "& span": {
            color: "#666",
        },
        "&::-webkit-scrollbar": {
            display: 'none',
        }
    },
    marginBottomSM: {
        marginBottom: 14
    }
});

interface LocalEntityDialogProps extends WithStyles<typeof styles> {
    isDialogOpen: boolean,
    dialogCloseHandler: () => void,
    selectedEntity: any,
    courseData: any,
    LocalEntityUpdateHandler: Function,
    orderNo: string,
    totalCount: number,
    onSequenceNumberEdit: Function,
    showAddContent: boolean,
    showError: boolean,
    handleError: Function
}

interface LocalEntityDialogState {
    formData: any,
    isUpdate: boolean,
    inputTitle: string,
    sequenceNo: string,
    allowEdit: boolean,
    showSequenceError: boolean,
    sequenceErrorMsg: string


}

class LocalEntityDialog extends Component<LocalEntityDialogProps, LocalEntityDialogState> {
    constructor(props: LocalEntityDialogProps) {
        super(props);
        this.state = {
            allowEdit: false,
            isUpdate: false,
            inputTitle: '',
            sequenceNo: '',
            formData: {
                title: '',
                localId: '',
                class: '',
                mappedMaster: '',
                parents: '',
                goal: '',
                combineWith: [],
                masters: [],
                children: '',
                classType: '',
                parentType: '',
                childType: ''
            },
            showSequenceError: false,
            sequenceErrorMsg: ''


        };
        this.handleOnEdit = this.handleOnEdit.bind(this)
        this.dCloseHandler = this.dCloseHandler.bind(this);
        this.handleReplaceInMaster = this.handleReplaceInMaster.bind(this);
        this.handleInputTitleChange = this.handleInputTitleChange.bind(this);
        this.handleSequenceNoChange = this.handleSequenceNoChange.bind(this);

    }

    componentWillUnmount() {

    }

    dCloseHandler() {
        this.props.dialogCloseHandler();
        this.setState({ isUpdate: false, allowEdit: false, showSequenceError: false });
    }

    componentDidUpdate(prevProps: any) {
        if(prevProps.showError !== this.props.showError) {
            if(this.props.showError && _.get(this.props.selectedEntity, 'selfDetails.type', '') === 'subject') {
                this.setState({
                    showSequenceError: true,
                    allowEdit: true,
                    sequenceErrorMsg: 'Subject from other class exist at this position'
                })
            }
        }
    }

    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (!_.isEmpty(nextProps.selectedEntity) && !prevState.isUpdate) {
            let selectedEntity = nextProps.selectedEntity;
            let title = `${_.get(selectedEntity["selfDetails"], 'name', '')} (Local)`;
            let localId = _.get(selectedEntity["selfDetails"], 'uniqueCode', '');
            let sequenceNumber = _.get(selectedEntity["selfDetails"], 'sequenceNumber', '');
            if(sequenceNumber === '') {
                let parentData = _.cloneDeep(nextProps.courseData.find((cd: any) => (cd._id == selectedEntity.selfDetails.parent.id)));
                let order = _.get(selectedEntity["selfDetails"], 'orderNo', 1)
                order = (order < 10) ? '0' + order.toString() : order.toString();
                sequenceNumber = parentData.sequenceNumber + order;
                }
            let parentType = '';
            let childType = '';
            let goal = '';
            let mappedMaster = '';
            let classType = ''

            //class type chip
            if (selectedEntity["selfDetails"]) {
                classType = _.upperFirst(_.get(selectedEntity["selfDetails"], "type", ""));
                mappedMaster = _.get(selectedEntity["selfDetails"], "masterIDs", "");
            }

            //ActiveCourse targeteYear
            if (selectedEntity["activeCourse"]) {
                goal = `${_.get(selectedEntity["activeCourse"], 'name', '')} (${_.get(selectedEntity["activeCourse"], 'targetYear', '')})`
            }

            let className: any = [];
            if (selectedEntity["activeCourse"] && selectedEntity["activeCourse"] && selectedEntity["activeCourse"]["class"] && selectedEntity["activeCourse"]["class"].length > 0) {
                className = selectedEntity["activeCourse"]["class"].map((c: any) => c.name);
            }
            className = `Class ${className.join(', ')}`;

            let parents: any = [];
            if (selectedEntity["parentDetails"] && selectedEntity["parentDetails"] && selectedEntity["parentDetails"].length > 0) {
                parentType = selectedEntity["parentDetails"][0]["type"];
                parents = selectedEntity["parentDetails"].map((c: any) => c.name);
            }
            parents = parents.join(', ');

            let children: any = [];
            if (selectedEntity["childDetails"] && selectedEntity["childDetails"] && selectedEntity["childDetails"].length > 0) {
                childType = selectedEntity["childDetails"][0]["type"];
                children = selectedEntity["childDetails"].map((c: any) => c.name);
            }
            children = children.join(', ');
            let inputTitle = title;
            let sequenceNo = sequenceNumber;

            let formData = {
                _id: _.get(selectedEntity, 'selfDetails._id', []),
                parent: _.get(selectedEntity, 'selfDetails.parent', []),
                courseId: _.get(selectedEntity, 'selfDetails.courseId', []),
                title,
                localId,
                className,
                goal,
                parents,
                mappedMaster,
                children,
                splitsInto: {},
                combineWith: _.get(selectedEntity, 'selfDetails.combineWith', []),
                masters: _.get(selectedEntity, 'selfDetails.masters', []),
                classType,
                parentType,
                childType
            }

            return { formData, inputTitle, sequenceNo }
        }
        else
            return null;
    }

    handleOnFocus = (evt: any) => {
        let { inputTitle }: any = this.state;
        const { value } = evt.target;

        inputTitle = value.replace(' (Local)', '');
        return this.setState({ inputTitle, isUpdate: true });

    }

    handleInputTitleChange = (evt: any) => {
        let { inputTitle, allowEdit }: any = this.state;
        const { value } = evt.target;
        inputTitle = value.replace(' (Local)', '');
        if (allowEdit) {
            return this.setState({ inputTitle });
        }
    }
    handleSequenceNoChange = (evt: any) => {
        let { sequenceNo, allowEdit }: any = this.state;
        const { value } = evt.target;
        this.setState({
            showSequenceError: false
        })
        this.props.handleError();

        let type = _.get(this.props.selectedEntity, 'selfDetails.type', '')
        switch(type) {
            case 'subject': 
            if(value.length <=2 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
            case 'sub-subject': 
            if(value.length >=2 && value.length <=4 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
            case 'chapter': 
            if(value.length >=4 && value.length <=6 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
            case 'concept': 
            if(value.length >=6 && value.length <=8 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;

        }
    }

    handleKeyDownOnSequenceNo = (evt: any) => {
        let type = _.get(this.props.selectedEntity, 'selfDetails.type', '')
        const { value } = evt.target;
        this.setState({
            showSequenceError: false
        })

        switch(type) {
            case 'subject': 
            break;
            case 'sub-subject':    
            if(evt.keyCode === 8 && value.length >=2 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
            case 'chapter': 
            if(evt.keyCode === 8 && value.length >=4 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
            case 'concept': 
            if(evt.keyCode === 8 && value.length >=6 ) {
                this.setState({ sequenceNo: value, isUpdate: true });
            }
            break;
        }
    }

    checkSequenceCount(seqNo: string, type:string) {

        switch(type) {
            case 'subject': return seqNo.length === 2
            case 'sub-subject': return seqNo.length === 4
            case 'chapter': return seqNo.length === 6
            case 'concept':return seqNo.length === 8
        }
    }

    handleOnBlurTitleChange = () => {
        let { selectedEntity: { selfDetails }, courseData, totalCount } = this.props;
        let { inputTitle, formData, allowEdit, sequenceNo } = this.state;
        let newselfDetails = _.cloneDeep(courseData.find((cd: any) => (cd._id == selfDetails._id)));
        let previousData = newselfDetails.sequenceNumber;
        newselfDetails.name = inputTitle;
        newselfDetails.sequenceNumber = sequenceNo;
        if(!inputTitle.includes('Local')) {
            inputTitle = inputTitle + ' (Local)';
        }
        let seqNo = sequenceNo.slice(-2);
        if (this.checkSequenceCount(sequenceNo, _.get(selfDetails, 'type', '')) && parseInt(seqNo) !== 0 && parseInt(seqNo) <= totalCount) {
            if(previousData !== sequenceNo) {
            this.setState({ allowEdit: !allowEdit });
            let dragOverIndex = parseInt(seqNo) - 1;
            this.props.onSequenceNumberEdit(_.get(selfDetails, 'orderNo', 1) - 1, _.get(selfDetails, 'parent', 1), _.get(selfDetails, 'type', ''), dragOverIndex)
            } else {
                this.setState({ allowEdit: !allowEdit });
            }
        } else {
            this.setState({
                showSequenceError: true,
                sequenceErrorMsg: `No ${_.get(this.props.selectedEntity, 'selfDetails.type', '')} exists at this position`
            })
        }

    }

    handleReplaceInMaster() {
        const { formData } = this.state;
        let reqBody = {
            courseSyllabusId: formData._id,
            parentId: formData.parent,
            courseId: formData.courseId,
        }
        goalManagementService.replaceInMaster(reqBody)
            .then(() => {
                this.props.LocalEntityUpdateHandler();
                this.props.dialogCloseHandler();
            })
    }

    handleOnEdit() {
        let { allowEdit } = this.state;
        this.setState({ allowEdit: !allowEdit });
    }

    render() {
        const {
            classes,
            isDialogOpen,
            selectedEntity
        } = this.props;

        const {
            formData,
            inputTitle,
            allowEdit,
            sequenceNo,
            showSequenceError,
            sequenceErrorMsg
        } = this.state;

        const otherDialogProps = {
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
        }

        const typeCode = selectedEntity['selfDetails'] && selectedEntity['selfDetails'].typeCode && selectedEntity['selfDetails'].typeCode.length ? `${selectedEntity['selfDetails'].typeCode}` : '';

        return (
            <MyPATDialog
                dialogOpen={isDialogOpen}
                otherDialogProps={otherDialogProps}
                onDialogClose={this.dCloseHandler}
                customDialogTitle={
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item xs>
                            {formData.title}
                            <div className={classes.inline}><Chip className={cx(classes.subSubjectChip, classes.chipLightGreen)}
                                label={formData.classType}
                            /></div>
                        </Grid>

                        <Grid item xs="auto" className={classes.dialogCloseContainer}>
                            {!this.state.allowEdit ?
                                <>
                                    <Button
                                        className={`${[classes.btnEdit, classes.btnHover].join(' ')} ${!this.props.showAddContent ? classes.btnDisable : ''}`}
                                        disabled={!this.props.showAddContent}

                                        onClick={this.handleOnEdit}>
                                        <span><EditIcon /></span>Edit
                                    </Button>
                                </>
                                :
                                <>
                                    <Button
                                        className={[classes.btnEdit, classes.btnHover].join(' ')}
                                        onClick={this.handleOnBlurTitleChange.bind(this)}>
                                        Save
                                    </Button>
                                </>
                            }
                            <MyPATIconButton classes={{flat: classes.borderStyle}} 
                            buttonVariant="flat" 
                            onClick={this.dCloseHandler}>
                                <CloseIcon/>
                            </MyPATIconButton>
                        </Grid>
                    </Grid>
                }
                customDialogActions={
                    <Button
                        variant="contained" color="primary"
                        onClick={this.handleReplaceInMaster}
                    //disabled={true}
                    >
                        Replace in Master
                        </Button>
                }
            >
                <Card className={classes.card}>
                    <CardContent className={[classes.cardContentRoot, !allowEdit ? classes.disableField : ''].join(' ')}>
                        <Grid container alignItems="center">
                            <Grid container spacing={16}>
                                <Grid item xs={6}>
                                    <div className={classes.editTitle}>
                                        <MyPATTextField
                                            inputId="localtitle"
                                            label="Title"
                                            name="title"
                                            className={classes.marginBottomSM}
                                            value={inputTitle}
                                            fullWidthControl
                                            onFocus={this.handleOnFocus.bind(this)}
                                            onChange={this.handleInputTitleChange.bind(this)}
                                            disabled={allowEdit}
                                        />
                                    </div>
                                </Grid>
                                {typeCode.length > 0 && <Grid item xs={3}>
                                    <MyPATTextField
                                        inputId="materCode"
                                        label="Master Code"
                                        name="masterCode"
                                        className={classes.marginBottomSM}
                                        readOnly
                                        value={typeCode}
                                        fullWidthControl
                                        disabled={allowEdit}
                                    />
                                </Grid>}
                                <Grid item xs={3}>
                                    <MyPATTextField
                                        inputId="localId"
                                        label="Sequence Id"
                                        name="localId"
                                        className={classes.marginBottomSM}
                                        value={formData.localId}
                                        fullWidthControl
                                        disabled={allowEdit}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <MyPATTextField
                                        inputId="localId"
                                        label="Sequence No."
                                        name="localId"
                                        className={classes.marginBottomSM}
                                        value={sequenceNo}
                                        fullWidthControl
                                        error={showSequenceError}
                                        disabled={!allowEdit}
                                        errorText={sequenceErrorMsg}
                                        onChange={this.handleSequenceNoChange}
                                        onKeyDown={this.handleKeyDownOnSequenceNo.bind(this)}
                                        type="number"
                                        endAdornment={
                                            <span></span>
                                          }
                                        
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={16}>
                                <Grid item xs={6}>
                                    <Typography variant="body1">Mapped Master(s) and ID(s)</Typography>
                                    <div className={classes.masters}>
                                        {
                                            _.get(formData, 'masters', []).map((m: any, i: number) => {
                                                return (<div className={classes.inline} key={`mapped_${i}`} >{_.get(m, "name", "")} <span>{_.get(m, "_id", "")}</span>,</div>)
                                            })
                                        }
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <MyPATTextField
                                        inputId="classes"
                                        label="Class(s)"
                                        name="class"
                                        className={classes.marginBottomSM}
                                        fullWidthControl
                                        value={formData.className}
                                        disabled={allowEdit}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <MyPATTextField
                                    inputId="goal"
                                    label="Goal"
                                    name="goal"
                                    className={classes.marginBottomSM}
                                    fullWidthControl
                                    value={formData.goal}
                                    disabled={allowEdit}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={classes.title} variant="caption">Local Parent(s)
                                    {!_.isEmpty(formData.parentType) &&
                                        <Chip className={cx(classes.subSubjectChip, classes.chipLightRed)} label={formData.parentType} />
                                    }
                                </Typography>
                                <MyPATTextField
                                    inputId="parent"
                                    name="parent"
                                    className={classes.marginBottomSM}
                                    value={formData.parents}
                                    fullWidthControl
                                    disabled={allowEdit}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography className={classes.title} variant="caption">Local Children
                                {
                                        !_.isEmpty(formData.childType) &&
                                        <Chip className={cx(classes.subSubjectChip, classes.chipLightBlue)} label={formData.childType} />

                                    }
                                </Typography>
                                <MyPATTextField
                                    inputId="children"
                                    name="children"
                                    value={formData.children}
                                    fullWidthControl
                                    className={classes.marginBottomSM}
                                    disabled={allowEdit}
                                />
                            </Grid>
                            <Grid container spacing={16}>
                                <Grid item xs={6}>
                                    <MyPATTextField
                                        inputId="children"
                                        name="children"
                                        label="Combines With to from Master"
                                        value={formData.combineWith.map(((c: any) => c.name)).join(", ")}
                                        fullWidthControl
                                        className={classes.marginBottomSM}
                                        disabled={allowEdit}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
            </MyPATDialog>
        )
    }
}

// @ts-ignore
export default withStyles(styles)(LocalEntityDialog);